import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    items: [],
    editingItems: []
};

export default {mutations, actions, state}
